import { render, staticRenderFns } from "./Variacaofaturamento.vue?vue&type=template&id=1d93fafe&"
import script from "./Variacaofaturamento.vue?vue&type=script&lang=js&"
export * from "./Variacaofaturamento.vue?vue&type=script&lang=js&"
import style0 from "./Variacaofaturamento.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports